import { MapColorTheme, MapColorSlotDefinition } from "@app/shared/map-appearance/interfaces";

export const OVERLAP_ONE_COUNTY_FILL_DEFAULT_THEME = "rgba(241, 207, 239, 1)";
export const OVERLAP_TWO_COUNTY_FILL_DEFAULT_THEME = "rgba(242, 163, 238, 1)";
export const OVERLAP_THREE_COUNTY_FILL_DEFAULT_THEME = "rgba(216, 109, 205, 1)";
export const OVERLAP_FOUR_COUNTY_FILL_DEFAULT_THEME = "rgba(195, 51, 182, 1)";
export const OVERLAP_FIVE_COUNTY_FILL_DEFAULT_THEME = "rgba(120, 33, 112, 1)";
export const SELECTED_COUNTY_FILL_DEFAULT_THEME = "rgba(220, 236, 255, 1)";
export const UNSELECTED_COUNTY_FILL_DEFAULT_THEME = "rgba(240, 240, 252, 1)";

export const COMPETITIVE_INSIGHTS_DEFAULT_COLOR_THEME: MapColorTheme = {
  colors: {
    overlapFiveCountyFillColor: OVERLAP_FIVE_COUNTY_FILL_DEFAULT_THEME,
    overlapFourCountyFillColor: OVERLAP_FOUR_COUNTY_FILL_DEFAULT_THEME,
    overlapOneCountyFillColor: OVERLAP_ONE_COUNTY_FILL_DEFAULT_THEME,
    overlapThreeCountyFillColor: OVERLAP_THREE_COUNTY_FILL_DEFAULT_THEME,
    overlapTwoCountyFillColor: OVERLAP_TWO_COUNTY_FILL_DEFAULT_THEME,
    selectedCountyFillColor: SELECTED_COUNTY_FILL_DEFAULT_THEME,
    unselectedCountyFillColor: UNSELECTED_COUNTY_FILL_DEFAULT_THEME,
  },
  name: "Default",
  uuid: "competitive-insights-default",
};

export const COMPETITIVE_INSIGHTS_PRESET_THEMES: MapColorTheme[] = [
  COMPETITIVE_INSIGHTS_DEFAULT_COLOR_THEME,
];

export const COMPETITIVE_INSIGHTS_COLOR_SLOT_DEFINITIONS: MapColorSlotDefinition[] = [
  { key: "overlapOneCountyFillColor", label: "One Overlapped County Fill" },
  { key: "overlapTwoCountyFillColor", label: "Two Overlapped Counties Fill" },
  { key: "overlapThreeCountyFillColor", label: "Three Overlapped Counties Fill" },
  { key: "overlapFourCountyFillColor", label: "Four Overlapped Counties Fill" },
  { key: "overlapFiveCountyFillColor", label: "Five Overlapped Counties Fill" },
  { key: "selectedCountyFillColor", label: "Selected County Fill" },
  { key: "unselectedCountyFillColor", label: "Unselected County Fill" },
];
